import React from "react";


import { FilterSectionFlexboxGrid, StyledItemFitWidth } from "components/base/FitContainers";

import { Radio, RadioGroup } from "rsuite";

const FiltersPanel = ({
    isMobile,
    loading,
    isGanTrunks,
    isTransitTrunks,
    onChangeGroup,
    filterNode,
    rightNode,
}) => {
    return (
        <FilterSectionFlexboxGrid controlable={!isMobile}>
            <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile} column>
                {isGanTrunks ?
                    <RadioGroup
                        inline
                        onChange={onChangeGroup}
                        defaultValue={"numbers"}
                        name="radioList"
                        styled={{ marginLeft: 10 }}
                    >
                        <Radio value="numbers" disabled={loading}>Numbers</Radio>
                        <Radio value="groups" disabled={loading}>Groups</Radio>
                    </RadioGroup>
                    : <></>
                }

                {!isTransitTrunks && !isMobile ? filterNode : <></>}

                {!isMobile && !isTransitTrunks
                    ? !isGanTrunks && (
                        <RadioGroup
                            inline
                            onChange={onChangeGroup}
                            defaultValue={"trunk_number"}
                            name="radioList"
                            style={{ marginLeft: 10 }}
                        >
                            <Radio value="trunk_number" disabled={loading}>Numbers</Radio>
                            <Radio value="price_range" disabled={loading}>Ranges</Radio>
                            <Radio value="subdestination" disabled={loading}>Subdestinations</Radio>
                        </RadioGroup>)
                    : filterNode
                }
            </StyledItemFitWidth>

            {rightNode}
        </FilterSectionFlexboxGrid>
    );
};

export default FiltersPanel;
